export const LoadingSkeleton = () => (
  <div className="w-100 bg-body-tertiary rounded animate__animated animate__flash animate__infinite-infinite-2000ms" style={{ minHeight: '31px' }} />
);